import React from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

interface ImageTextSection {
    id: number;
    imageFile?: File | null;
    bodyCopy?: string;
    imagePath?: string; // relative path from backend
}

interface TextImageProps {
    section: ImageTextSection;
    onChange: (id: number, updatedData: Partial<ImageTextSection>) => void;
    onClose: () => void;
    baseUrl?: string; // optional base URL
}

const TextImage: React.FC<TextImageProps> = ({ section, onChange, onClose, baseUrl }) => {

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(section.id, { imageFile: e.target.files?.[0] || null });
    };

    const ReactQuill = require('react-quill');
    const handleBodyChange = (value: string) => {
        onChange(section.id, { bodyCopy: value });
    };

    const getImageSrc = () => {
        if (section.imageFile) return URL.createObjectURL(section.imageFile);
        if (section.imagePath) return baseUrl ? `${baseUrl}${section.imagePath}` : section.imagePath;
        return undefined;
    };

    return (
        <div style={{
            padding: '10px',
            marginBottom: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: 'fit-content'
        }}>
            <button
                style={{ position: 'absolute', top: 5, right: 5, border: 'none', background: 'none', color: 'black', cursor: 'pointer' }}
                onClick={onClose}
            >
                X
            </button>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', width: '100%' }}>
                {/* TEXT */}
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column', marginTop: '10px', height: 'fit-content' }}>
                    <label>Text Content</label>
                    <ReactQuill
                        value={section.bodyCopy || ''}
                        onChange={handleBodyChange}
                        modules={{
                            toolbar: [
                                [{ header: [1, 2, 3, false] }],
                                ['bold', 'italic', 'underline', 'strike'],
                                [{ 'color': [] }, { 'background': [] }],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                [{ 'align': [] }],
                                ['link', 'image'],
                                ['clean'],
                            ]
                        }}
                        theme="snow"
                        style={{ minHeight: '150px', width: '100%' }}
                    />
                </div>

                {/* IMAGE */}
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>Image (Required)</label>
                    <input type="file" className="form-control" onChange={handleFileChange} />
                    {getImageSrc() && (
                        <img
                            src={getImageSrc()}
                            alt="Preview"
                            style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '5px', marginTop: '5px' }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default TextImage;
